import { Button, Spinner } from "reactstrap";

import './DangerButton.scss'

const DangerButton = (props) => {
  return (
    <Button
      className='danger-button'
      {...props}
      disabled={props?.loading || props?.disabled ? true : false}
    >
      {props?.loading &&
        <Spinner size="sm"></Spinner>
      }

      {props?.icon &&
        <img src={props?.icon} alt="" />
      }
      <p>
        {props.text}
      </p>
    </Button>
  )
}

export default DangerButton;